import { useRegionContext } from 'common/contexts/RegionContext';
import * as React from 'react';
import { RegionKey } from 'services/clients/regions';

interface Props {
  /** if provided, will only render children if this region is available */
  targetRegionKey?: RegionKey;
}

/**
 * When no props are provided, renders children only when there is more than 1 region
 * When a targetRegionKey is provided, renders children only when that region is available
 */
export const RegionalWrapper: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { targetRegionKey, children } = props;

  const { availableRegions } = useRegionContext();

  if (targetRegionKey && !availableRegions.map((r) => r.code).includes(targetRegionKey)) {
    return null;
  }

  if (!targetRegionKey && availableRegions.length <= 1) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
RegionalWrapper.displayName = 'RegionalWrapper';
